import React, { useState, useContext, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { Button, Input, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { LoginContext } from "../../../contexts/loginContext";
import createInstance from "../../../api/axiosinstance";
import Modal from "../Modal";
import Toast from "../../../utils/toast";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";

const DepartmentManagement = () => {
  // const { isLoggedIn, adminId: admin_id } = useContext(LoginContext);
  const [deptName, setDeptName] = useState("");
  const [creationDate] = useState(new Date().toISOString());
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deptData, setDeptData] = useState([]);
  const [deptId, setDeptId] = useState();
  const [editingRowId, setEditingRowId] = useState(null);
  const [editedName, setEditedName] = useState("");
  const [deactivateId, setDeactiveId] = useState("");
  const [editedId, setEditedId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortingOrder, setSortingOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const admin_id = user?.user_id;
  const aiDishaApi = createInstance("DISHA");

  useEffect(() => {
    fetchData();
    console.log("res", user);
  }, []);
  useEffect(() => {
  setPage(0);
}, [searchTerm]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchData = async () => {
    try {
      const response = await aiDishaApi.get(`/all-departments/`);

      console.log("Fetched data from API:", response.data);

      if (response.data?.departments) {
        setDeptData(response.data.departments);
      } else {
        console.error("Unexpected response structure:", response.data);
      }
    } catch (error) {
      console.error(
        "Error fetching dept data:",
        error.response?.data?.message || error.message
      );
    }
  };
  useEffect(() => {
    if (deptName === "") {
      setPage(0); // Reset pagination to the first page
      setIsEdit(false); // Exit edit mode
    }
  }, [deptName]);

  const handleSort = (field) => {
    const sortedData = [...deptData].sort((a, b) => {
      if (sortingOrder === "asc") {
        return a[field].localeCompare(b[field]);
      } else {
        return b[field].localeCompare(a[field]);
      }
    });
    setDeptData(sortedData);
    setSortingOrder(sortingOrder === "asc" ? "desc" : "asc");
  };
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };
  // Filter department data based on search term
  const filteredDeptData = deptData.filter((dept) =>
    (dept.dept_name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDeptSubmit = async () => {
    try {
      if (!deptName.trim()) {
        console.error("Department name cannot be empty");
        Toast.error("Department name cannot be empty");
        return;
      }
      const existingDept = deptData.find((dept) => dept.dept_name === deptName);
      if (existingDept) {
        console.error("Department name already exists");
        Toast.error("Department name already exists");
        return;
      }
      console.log("Submitting with admin_id:", admin_id, "deptName:", deptName);

      // Make the POST request with admin_id as a query parameter
      const response = await aiDishaApi.post(
        `/admin-departments/?admin_id=${admin_id}`,
        {
          dept_name: deptName,
          creation_date: creationDate,
          status: "Active",
        }
      );

      if (response.status === 200) {
        Toast.success("Dept added successfully");
        setDeptName("");
        fetchData();
      }
    } catch (error) {
      console.error("Error:", error.response?.data?.message || error.message);
      Toast.error(error.response?.data?.message || "Failed to add department");
    }
  };

  const handleEdit = (id, name) => {
    setDeptId(id);
    setEditedName(name);
    setDeptName(name);
    setIsEdit(true);
  };

  const handleDeptEdit = async (dept_id) => {
    try {
      const existingDept = deptData.find(
        (dept) => dept.dept_name === deptName && dept.dept_id !== dept_id
      );
      if (existingDept) {
        console.error("Department name already exists");
        Toast.error("Department name already exists");
        return;
      }

      // If the department name is unique, proceed with the update
      const updateResponse = await aiDishaApi.put(
        `/admin-departments-update?dept_id=${dept_id}&admin_id=${admin_id}`,
        {
          dept_name: deptName,
          updated_date: new Date().toISOString(),
        }
      );

      if (updateResponse.status === 200) {
        Toast.success("Department updated successfully");
        setDeptName("");
        fetchData();
        setIsEdit(false);
      }
      const updatedDeptData = deptData.map((dept) => {
        if (dept.dept_id === deptId) {
          return { ...dept, dept_name: deptName };
        } else {
          return dept;
        }
      });
      setDeptData(updatedDeptData);
      setIsEdit(false);
      setDeptName("");
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setEditingRowId(null);
    }
  };

  const handleClear = () => {
    setDeptName("");
    setDeptId("");
    setSearchTerm("");
  };

  const handleModalOpen = (dept_id, status) => {
    console.log("dept_id handlemodal check", dept_id);
    console.log("dept_id status handlemodal check", status);
    setDeactiveId(dept_id);
    setSelectedStatus(status);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleDeactivateDept = async (dept_id, currentStatus) => {
    console.log("dept_id status check", dept_id);
    console.log("dept_id status check", currentStatus);
    try {
      const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

      const response = await aiDishaApi.patch(
        `/admin-departments-status/?dept_id=${dept_id}&admin_id=${admin_id}&status_update=${newStatus}`
      );

      if (response.status === 200) {
        Toast.success("Department Status Updated successfully");
        fetchData();
      }
      if (response.status === 200) {
        const updatedDeptData = deptData?.filter(
          (dept) => dept.dept_id !== deactivateId
        );
        setDeptData(updatedDeptData);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const deptHeader = [
    {
      id: "Department ID",
      name: "Department Name",
      creationDate: "Creation Date",
      action: "Action",
    },
  ];

  const CssTextField = styled(TextField)({
    "& label": {
      color: "#FEFEFE",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
        borderRadius: 10,
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#B9B9B9",
      },
      "& .MuiInputBase-input": {
        color: "#FEFEFE",
      },
    },
  });

  return (
    <div>
      {isEdit ? (
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "30px",
            alignItems: "center",
            background: alpha("#033538", 1), // Opacity set to 20%,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "20px" }}
          >
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "28px", color: "white" }}
            >
              Edit Department
            </Typography>
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "16px", color: "white" }}
            >
              Edit the name of the Department
            </Typography>
          </Box>

          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          >
            <Paper
              sx={{
                p: "2px 4px",
                display: "flex",
                width: "75%",
                borderRadius: 2,
                backgroundColor: "#006A71", // Set background color to black
              }}
            >
              <IconButton
                type="button"
                sx={{ p: "8px", color: "white" }}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, fontFamily: "Poppins", color: "white" }} // Set text color to white
                placeholder="Search by Department Name"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </Paper>
          </Box>

          <Box
            gridColumn="span 5"
            sx={{ marginTop: "auto", textAlign: "left" }}
          >
            <Typography sx={{ fontFamily: "poppins", color: "white" }}>
              Department Name
            </Typography>
            <TextField
              size="small"
              id="custom-css-outlined-input"
              label="Dept Name"
              variant="outlined"
              value={deptName}
              onChange={(e) => setDeptName(e.target.value)}
              sx={{
                color: "white",
                width: "95%",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                  borderRadius: "10px",
                },
                "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "grey",
                  },
                "& .MuiInputLabel-root": {
                  color: "white",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "white", // Optional: Change label color when focused
                },
                "& .MuiInputBase-input": {
                  color: "white", // This sets the text color to white
                },
                "& .MuiOutlinedInput-root": {
                  color: "white", // This also helps with input text color
                },
              }}
              required
            />
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color: "white",
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Clear
            </Button>
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              sx={{
                background: "#006A71",
                color: "white",
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
              onClick={() => handleDeptEdit(deptId)}
            >
              <Typography sx={{ fontFamily: "poppins", color: "white" }}>
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
      ) : (
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "30px",
            alignItems: "center",
            background: alpha("#033538", 1), // Opacity set to 20%,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "20px" }}
          >
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "28px", color: "white" }}
            >
              Add Department
            </Typography>
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "16px", color: "white" }}
            >
              Edit the name of the Department
            </Typography>
          </Box>

          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          >
            <Paper
              sx={{
                p: "2px 4px",
                display: "flex",
                width: "75%",
                borderRadius: 2,
                color: "white",
                backgroundColor: "#006A71", // Set background color to black
              }}
            >
              <IconButton
                type="button"
                sx={{ p: "8px", color: "white" }}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, fontFamily: "Poppins", color: "white" }} // Set text color to white
                placeholder="Search by Department Name"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </Paper>
          </Box>

          <Box
            gridColumn="span 5"
            sx={{ marginTop: "auto", textAlign: "left" }}
          >
            <Typography sx={{ fontFamily: "poppins", color: "white" }}>
              Department Name
            </Typography>
            <TextField
              size="small"
              id="outlined-input"
              label="Dept Name"
              variant="outlined"
              value={deptName}
              onChange={(e) => setDeptName(e.target.value)}
              sx={{
                width: "95%",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                  borderRadius: "10px",
                },
                "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "grey",
                  },
                "& .MuiInputLabel-root": {
                  color: "white",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "white", // Optional: Change label color when focused
                },
                "& .MuiInputBase-input": {
                  color: "white", // This sets the text color to white
                },
                "& .MuiOutlinedInput-root": {
                  color: "white", // This also helps with input text color
                },
              }}
              required
            />
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color: "white",
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Clear
            </Button>
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              sx={{
                background: "#006A71",
                color: "white",
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
              onClick={handleDeptSubmit}
            >
              <Typography sx={{ fontFamily: "poppins", color: "white" }}>
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
      )}

      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#006A71" }}>
                  {deptHeader.map(({ id, name, creationDate, action }) => (
                    <React.Fragment key={id}>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {id}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          borderBottom: 0,
                          cursor: "pointer",
                        }}
                        onClick={() => handleSort("dept_name")}
                      >
                        {name} {sortingOrder === "asc" ? "↑" : "↓"}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {creationDate}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {action}
                      </TableCell>
                    </React.Fragment>
                  ))}
                </TableHead>
                <TableBody>
                  {filteredDeptData &&
                    filteredDeptData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((n, index) => (
                        <TableRow
                          key={n.dept_id}
                          sx={{
                            backgroundColor: "#033538",
                            marginRight: "30px",
                          }}
                        >
                          <TableCell
                            sx={{ color: "white", border: "1px solid black" }}
                          >
                            {n.dept_id}
                          </TableCell>
                          <TableCell
                            sx={{ color: "white", border: "1px solid black" }}
                          >
                            {editingRowId === n.dept_id ? (
                              <Input
                                value={editedName}
                                onChange={(e) => setEditedName(e.target.value)}
                              />
                            ) : (
                              n.dept_name
                            )}
                          </TableCell>
                          <TableCell
                            sx={{ color: "white", border: "1px solid black" }}
                          >
                            {new Date(n.creation_date).toLocaleDateString(
                              "en-GB"
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: "1px solid black",
                              borderRight: "1px solid black",
                              display: "flex",
                              alignItems: "center",
                              fontFamily: "poppins",
                            }}
                          >
                            {editingRowId === n.dept_id ? (
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: "black",
                                  color: "#A7A7A7",
                                  marginRight: "10px",
                                  fontFamily: "poppins",
                                  height: "20px",
                                  width: "30px",
                                }}
                              >
                                Save
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                onClick={() =>
                                  handleEdit(n.dept_id, n.dept_name)
                                }
                                sx={{
                                  backgroundColor: "black",
                                  color: "white",
                                  marginRight: "10px",
                                  fontFamily: "poppins",
                                  height: "20px",
                                  width: "30px",
                                }}
                              >
                                Edit
                              </Button>
                            )}
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor:
                                  n.status === "Active" ? "#f44336" : "#4caf50",
                                color: "#ffffff",
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "90px",
                                fontSize: "0.75rem",
                              }}
                              onClick={() => {
                                console.log(
                                  "Deactivate button clicked for:",
                                  n.dept_id,
                                  n.status
                                );
                                handleModalOpen(n.dept_id, n.status);
                              }}
                            >
                              {/* Deactivate */}
                              {n.status === "Active"
                                ? "Deactivate"
                                : "Activate"}
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={filteredDeptData ? filteredDeptData.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  backgroundColor: "#006A71",
                  color: "#B9B9B9",
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title="Department"
        action={() => handleDeactivateDept(deactivateId, selectedStatus)}
        actionType={selectedStatus === "Active" ? "Deactivate" : "Activate"}
      />
    </div>
  );
};

export default DepartmentManagement;
